function getFiltersFromURL(search) {
  const searchParams = new URLSearchParams(search);
  return {
    grade: searchParams.get("filterGrade") ?? undefined,
    category: searchParams.get("filterCategory") ?? undefined
  };
}

export { getFiltersFromURL };
//# sourceMappingURL=util.get-filters-from-url.js.map
